import env from './lib/env';
import phone from './phone';
import ipad from './ipad';
import mac from './mac';
import pc from './pc';
import h5 from './h5';
import wetv from './wetv';
import kid from './kid';
import { getVersion } from './lib/Version';
var JSBridge;

if (!env.isApp) {
  JSBridge = h5;
} else if (env.isWetv) {
  JSBridge = wetv;
} else if (env.isKidApp) {
  JSBridge = kid;
} else {
  switch (env.device) {
    case 'mac':
      JSBridge = mac;
      break;

    case 'windows':
      JSBridge = pc;
      break;

    case 'ipad':
    case 'apad':
      JSBridge = ipad;
      break;

    default:
      JSBridge = phone;
  }
}

if (env.isBaseApp && getVersion().compare('8.2.5')) {
  // 8.2.5 版本开始主线版本走 phone 端接口
  JSBridge = phone;
}

console && console.log("[atom] is running in `".concat(env.isApp ? env.device : 'h5', "` environment!"));
export default JSBridge;